import { useEffect } from 'react';

/** Sets the browser tab title ("<title> — miroom"). */
export function useDocumentTitle(title: string | null) {
  useEffect(() => {
    document.title = title ? `${title} — miroom` : 'miroom';
  }, [title]);
}
